import React, { useEffect, useState } from 'react'
import { CModal, CModalBody, CModalFooter, CProgress, CProgressBar } from '@coreui/react'
import { raiseToast } from 'src/views/utils/helper'
let PROGRESS_CHECK = 25
const LiveStreamProgressModal = ({ name, liveStreamData, handleClose }) => {
  const [progress, setProgress] = useState(25)

  useEffect(() => {
    setTimeout(() => {
      if (PROGRESS_CHECK < 100) {
        raiseToast('error', 'Something went wrong please try again.')
        handleClose()
      }
      return
    }, 420000)

    setTimeout(() => {
      PROGRESS_CHECK = 50
      setProgress(50)
      setPreparing()
      return
    }, 30000)
  }, [])

  const setPreparing = () => {
    setTimeout(() => {
      PROGRESS_CHECK = 75
      setProgress(75)
      return
    }, 30000)
  }

  useEffect(() => {
    if (progress === 75 && liveStreamData?.server_data?.status === 'LIVE') {
      PROGRESS_CHECK = 100
      setProgress(100)
      setTimeout(() => {
        raiseToast('success', 'Live stream started successfully!')
        handleClose()
        return
      }, 7000)
    }
  }, [progress, liveStreamData])

  return (
    <CModal size="lg" scrollable visible={true} alignment="center" className=" border-0">
      <div
        className="px-5 text-white w-100 d-flex align-items-center"
        style={{ height: '3.8vw', backgroundImage: 'linear-gradient(to bottom, #646464, #111)' }}
      >
        <p style={{ fontSize: '1.5625vw' }} className="mb-0 line-clamp-1">
          {`Starting Live Stream '${name}'`}
        </p>
      </div>
      <CModalBody className="px-5 py-4">
        <p style={{ fontSize: '14px' }}>
          {`OTTDock LIVE Studio is requesting the live stream. This may take a few minutes.`}
        </p>
        <div
          className={`w-100 py-3 recording-progress-bar-main ${
            progress < 100 ? 'recording-progress-bar' : 'progress-bar-success'
          } `}
        >
          <CProgress className="">
            <CProgressBar className="text-white text-left overflow-visible px-2" value={progress}>
              {progress === 25 ? ' Requesting ...' : ''}
              {progress === 50 ? ' Initializing ...' : ''}
              {progress === 75 ? ' Preparing ...' : ''}
              {progress === 100 ? 'Stream is Ready' : ''}
            </CProgressBar>
          </CProgress>
        </div>
      </CModalBody>
      <CModalFooter className={` border-0 `}></CModalFooter>
    </CModal>
  )
}

export default LiveStreamProgressModal
